// extracted by mini-css-extract-plugin
export default {"AdminPage":"AdminPage_AdminPage__rEsil","fadein":"AdminPage_fadein__76TQB","AdminPage__logoutButton":"AdminPage_AdminPage__logoutButton__+Dl4T","spin":"AdminPage_spin__wlFeq"};